import { StoryImagePlanEntity } from '../types/entities';

export type MotionPreset =
  | 'none'
  | 'zoom-in'
  | 'zoom-out'
  | 'zoom-in-out'
  | 'pan-left'
  | 'pan-right'
  | 'pan-up'
  | 'pan-down'
  | 'kenburns-left-in'
  | 'kenburns-right-in';

export type FillMode = 'mirror' | 'repeat' | 'hold';

export function motionDefaults(preset: MotionPreset | string): NonNullable<StoryImagePlanEntity['effectOptions']> {
  const base = { amount: 0.2, segmentMs: 5000, fillMode: 'mirror' as FillMode };
  switch (preset) {
    case 'none':
      return { amount: 0, segmentMs: 0, fillMode: 'hold' };
    case 'zoom-in':
    case 'zoom-out':
    case 'zoom-in-out':
      return base;
    case 'pan-left':
    case 'pan-right':
    case 'pan-up':
    case 'pan-down':
      return { ...base, amount: 0.15 };
    case 'kenburns-left-in':
    case 'kenburns-right-in':
      return { ...base, amount: 0.25 };
    default:
      return base;
  }
}

export function normalizeEffectPreset(val?: string | null): MotionPreset {
  const allowed: MotionPreset[] = ['none','zoom-in','zoom-out','zoom-in-out','pan-left','pan-right','pan-up','pan-down','kenburns-left-in','kenburns-right-in'];
  const v = String(val || 'zoom-in-out');
  return (allowed.includes(v as MotionPreset) ? v : 'zoom-in-out') as MotionPreset;
}

export function normalizeSubtitlePreset(val?: string | null): 'off' | 'typewriter-left' | 'typewriter-center' | 'karaoke-word' {
  const allowed = ['off','typewriter-left','typewriter-center','karaoke-word'] as const;
  const v = String(val || 'typewriter-center');
  return (allowed.includes(v as any) ? v : 'typewriter-center') as any;
}

export function normalizeWaveformPreset(val?: string | null): 'off' | 'bottom-center' | 'top-center' | 'under-subtitles' {
  const allowed = ['off','bottom-center','top-center','under-subtitles'] as const;
  const v = String(val || 'off');
  return (allowed.includes(v as any) ? v : 'off') as any;
}
